module.exports = __webpack_public_path__ + "img/tuxbuild_logo_orange.b7fbff05.svg";